import {createAsyncThunk} from '@reduxjs/toolkit'

import {OPEN_BANKING_TERMS_URL} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {ThunkApi} from '../interfaces'

/**
 * 오픈뱅킹 참여 금웅사 약관 페이지로 이동
 */
const navigateToOpenBankingTerms = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/openBankingTerms',
    async () => {
        if (isMobile) {
            changeBrowserLocation({
                url: OPEN_BANKING_TERMS_URL,
                type: 'PUSH',
            })
        } else {
            openNewTab({url: OPEN_BANKING_TERMS_URL})
        }

        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToOpenBankingTerms
